import { Property } from '@features/ForestOwner/Search/Overview/Property'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/forestowner/$forestownerId/property/')({
  component: RouteComponent,
  staticData: {
    breadcrumb: 'Eiendom',
  },
})

function RouteComponent() {
  return <Property />
}
